export default "__VITE_ASSET__CDo9WeTD__"